var map = {
	"./Dashboard.tsx": 12712,
	"./account/Update.tsx": 19693,
	"./auth/Login.tsx": 3461,
	"./auth/PasswordForgot.tsx": 45654,
	"./auth/PasswordReset.tsx": 10374,
	"./copyright-checker/afbeeldingen/index.tsx": 31377,
	"./copyright-checker/domeinen/:dossierId/CopyrightCheckerDomeinView.tsx": 79726,
	"./copyright-checker/domeinen/index.tsx": 59268,
	"./copyright-checker/dossiers/:dossierId/CopyrightCheckerDossier.stories.tsx": 17104,
	"./copyright-checker/dossiers/:dossierId/CopyrightCheckerDossier.tsx": 43555,
	"./copyright-checker/dossiers/:dossierId/CopyrightCheckerDossier.view.tsx": 47518,
	"./copyright-checker/dossiers/index.tsx": 53419,
	"./copyright-checker/overzicht/CopyrightCheckerDossiersOverview.stories.tsx": 33621,
	"./copyright-checker/overzicht/CopyrightCheckerDossiersOverview.tsx": 33652,
	"./copyright-checker/overzicht/CopyrightCheckerOverview.tsx": 9338,
	"./copyright-checker/overzicht/CopyrightCheckerOverview.view.tsx": 70459,
	"./copyright-checker/overzicht/CopyrightCheckerPhotoOverview.tsx": 71174,
	"./copyright-checker/overzicht/CopyrightCheckerPhotoOverview.view.tsx": 25058,
	"./copyright-checker/photo/create/UploadPhotos.stories.tsx": 61033,
	"./copyright-checker/photo/create/UploadPhotos.tsx": 98536,
	"./copyright-checker/photo/create/UploadPhotos.view.tsx": 44056,
	"./copyright-checker/photo/create/index.tsx": 75582,
	"./dossier/Claim.tsx": 20439,
	"./dossier/Communication.tsx": 66355,
	"./dossier/Create.tsx": 47576,
	"./dossier/Documents.tsx": 43497,
	"./dossier/Financial.tsx": 3762,
	"./dossier/Index.tsx": 86539,
	"./dossier/Invoices.tsx": 69452,
	"./dossier/Overview.tsx": 5569,
	"./dossier/Payments.tsx": 16801,
	"./dossier/RequestOverview.tsx": 68983,
	"./dossier/Requests.tsx": 57850,
	"./report/Create.tsx": 4282,
	"./report/ExportOverview.tsx": 82609,
	"./report/Overview.tsx": 23030,
	"./user/:id/Index.tsx": 86194,
	"./user/Create.tsx": 38290,
	"./user/Overview.tsx": 63920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13134;